import * as types from './mutation-types';

export default {
  [types.SET_SITE_UNIT_EVENTS](state, siteUnitEvents) {
    state.siteUnitEvents = siteUnitEvents.map(item => ({ ...item }));
  },
  [types.SET_ERRORS](state, errors) {
    state.errors = errors;
  }
};
